/* global dataLayer */

require('./vue/main.js');

(function(window, document, $) {
    'use strict';

    /**
     * Add active indicators to navigation
     */

    var thisLocation = location.href;

    if (thisLocation.match('/tuotteet/[a-z0-9]')) {
        thisLocation = '//' + location.host + '/tuotteet/';
    } else if (thisLocation.match('/referenssit/[a-z0-9]')) {
        thisLocation = '//' + location.host + '/referenssit/';
    }
    $('.js-primary-nav').find('a[href$="' + thisLocation + '"]').addClass('state-current').parents('li').find('> a').addClass('state-current');

    /**
     * Primary navigation toggle
     */
    var $navToggle = $('.js-primary-nav-toggle');

    $navToggle.on('click', function() {
        toggleClose($('.js-search-toggle'), $('.js-search-form'));
        toggleClose($('.js-user-toggle'), $('.js-user-controls'));
        toggleOpenClose($(this), $('.js-primary-nav'), false);
    });

    $('.js-submenu-toggle').on('click', function() {
        openNavLevel($(this), $(this).parent().find('.js-submenu-link'));
    });

    $('.js-submenu-link').on('click', function(e) {
        if ($navToggle.is(':hidden')) {
            e.preventDefault();
            openNavLevel($(this), $(this));
        }
    });

    $('.js-subsubmenu-toggle').on('click', function() {
        if ($navToggle.is(':visible')) {
            toggleOpenClose($(this), $(this).parent().find('.js-subsubmenu-container'), false);
        }
    });

    function openNavLevel($trigger) {
        var $subMenu = $trigger.parent().find('.js-submenu-container');

        if ($navToggle.is(':hidden') && $subMenu.is(':hidden')) {
            toggleClose($('.js-submenu-link'), $('.js-submenu-container'));
        }
        toggleOpenClose($trigger, $subMenu, false);
    }

    /**
     * Search form toggle
     */
    $('.js-search-toggle').on('click', function() {
        toggleClose($('.js-primary-nav-toggle'), $('.js-primary-nav'));
        toggleClose($('.js-user-toggle'), $('.js-user-controls'));
        toggleOpenClose($(this), $('.js-search-form'), $('.js-search-form').find('.js-search-field'));
    });

    /**
     * User controls form toggle
     */
    $('.js-user-toggle').on('click', function() {
        if (!$navToggle.is(':hidden')) {
            toggleClose($('.js-primary-nav-toggle, .js-search-toggle'), $('.js-primary-nav, .js-search-form'));
        }
        toggleOpenClose($(this), $('.js-user-controls'), false);
    });

    /**
     * Conversion stripe toggle
     */
    $('.js-conversion-open-extra').on('click', function() {
        var conversion = $(this).closest('.js-conversion-stripe');
        var conversionExtra = conversion.find('.js-conversion-extra');

        toggleOpenClose($(this), conversionExtra, conversionExtra.find('input:not("[type=hidden]"):first'));
    });

    /**
     * Toggle open/closed (+ sliding animation)
     *
     * - add/remove 'state-active' class to trigger element
     * - add/remove 'state-open' class to target element
     * - add 'aria-expanded' true/false to trigger element
     */

    function toggleOpenClose($trigger, $target, $focus) {
        if ($trigger.length > 0 && $target.length > 0) {
            if ($target.hasClass('state-open')) {
                toggleClose($trigger, $target);
            } else {
                toggleOpen($trigger, $target, $focus)
            }
        }
    }

    function toggleClose($trigger, $target) {
        if ($target.is(':visible')) {
            $target.fadeOut(100);
        }

        $target.removeClass('state-open');
        $trigger.removeClass('state-active').attr('aria-expanded', false);
    }

    function toggleOpen($trigger, $target, $focus) {
        if ($target.is(':hidden')) {
            $target.fadeIn(100);
        }

        $target.addClass('state-open');
        $trigger.addClass('state-active').attr('aria-expanded', true);

        if ($focus && $focus.length > 0) {
            $focus.focus();
        }
    }


    /**
     * Checkout page fuctionalities
     */

    $('input[type=radio][name=checkout-customer]').on('change', function() {
        if ($(this).val() == 'registered-customer') {
            $('.js-checkout__customer-form').hide();
            $('.js-checkout__registered-customer-login').show();
        }

        if ($(this).val().startsWith('new-customer')) {
            $('.js-checkout__customer-form').show();
            $('.js-checkout__registered-customer-login').hide();

            if ($(this).val().endsWith('-company')) {
                $('#billing_company_field, #billing_company_id_field').show();
            } else {
                $('#billing_company_field, #billing_company_id_field').hide();
            }
        }

        if ($(this).val() === 'new-customer-company') {
            $('input[value=paytrail]').parents('label').click();
            setTimeout(() => {
                $('input[value=klarna_payments]').parents('.checkout__header').hide();
            }, 1);
        } else {
            $('input[value=klarna_payments]').parents('.checkout__header').show();
        }

    });

    // Hack to get mandatory fields working with Vue
    setTimeout(() => {
        if ($('input[type=radio][name=checkout-customer]:checked').val().endsWith('-company')) {
            $('#billing_company_field, #billing_company_id_field').show();
        } else {
            $('#billing_company_field, #billing_company_id_field').hide();
        }
    }, 1);

    // Hack to prevent form inside form
    $('.js-checkout-login-form__login').on('click', function(e) {
        e.preventDefault();
        var login = $('.js-checkout-login-form__user-login').val();
        var password = $('.js-checkout-login-form__user-pass').val();
        $('#username').val(login);
        $('#password').val(password);
        $('#user-controls form').submit();
    });

    /**
      * Push to dataLayer after clicks
     */

    $('.ga-email, .ga-phone').on('click', function() {
        pushToDataLayer('eventTracking', 'Yhteydenotto', 'Klikkaus', $(this).data('ga') || $(this).text());
    });

})(this.window, this.document, jQuery);

/**
 * Push to dataLayer after Gform submit (ajax forms)
 * If you edit this, check also the non-ajax forms in gforms.php
 */

jQuery(function() {
    jQuery(document).on('gform_confirmation_loaded', function(event, formId) {
        pushToDataLayer('eventTracking', 'Yhteydenotto', 'Lomakelähetys', formId);
    });
});

function pushToDataLayer(event, category, action, label) {
    dataLayer.push({
        'event': event,
        'category': category,
        'action': action,
        'label': label,
    });
}
